import { Polygon } from '../model/polygon.model';
import { Component, OnInit } from '@angular/core';
import * as SVGFAIconsSolid from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss']
})
export class ContainerComponent implements OnInit {

  imageLoaded: boolean = false;
  leftPanelButtonLabel: string;
  leftPanelIcon: any;
  leftPanelClass: string;
  showLeftPanel: boolean = true;

  workareaSize: number;
  leftPanelSize: number;
  rightPanelSize: number;
  
  selectedFile: Subject<string> = new Subject();
  selectedTool: Subject<string> = new Subject();
  toolEvent: Subject<string> = new Subject();
  scaleEvent: Subject<number> = new Subject();
  savePlan: Subject<boolean> = new Subject();
  sendPlan: Subject<boolean> = new Subject();
  updatePrintData: Subject<boolean> = new Subject();
  rowSelection: Subject<{polygon: Polygon, selected: boolean}> = new Subject();
  undoDelete: Subject<string[]> = new Subject();
  undoCreate: Subject<string[]> = new Subject();
  undoResizeMove: Subject<string[]> = new Subject();
  undoAssignDict: Subject<string[]> = new Subject();
  redoCreate: Subject<string[]> = new Subject();
  redoResizeMove: Subject<string[]> = new Subject();
  redoAssignDict: Subject<string[]> = new Subject();
  deleteElements: Subject<string[]> = new Subject();
  polygonSelection: Subject<string> = new Subject();
  drawPolygon: Subject<[number, number][]> = new Subject();
  resizePolygon: Subject<[number, number][]> = new Subject();
  drawRect: Subject<[number, number][]> = new Subject();

  get solidIcons() {
    return SVGFAIconsSolid;
  }

  constructor() { }

  ngOnInit() {
    this.leftPanelButtonLabel = 'Chiudi';
    this.leftPanelClass = 'show-left-panel';
    this.leftPanelIcon = this.solidIcons.faBackward;
    this.leftPanelSize = 18;
    this.workareaSize = 55;
    this.rightPanelSize = 25;
  }

  getButtonStyle() {
    const height = document.getElementById('workarea').offsetHeight + 'px';
    return {'height': height};
  }

  changeLeftPanelVisibility() {
    if (this.showLeftPanel) {
      this.leftPanelButtonLabel = 'Espandi';
      this.leftPanelClass = 'hide-left-panel';
      this.leftPanelIcon = this.solidIcons.faForward;
      // setTimeout(() => {
      this.leftPanelSize = 0.1;
      // }, 333)
      this.workareaSize = 65;
      this.rightPanelSize = 33;
      this.showLeftPanel = false;
    } else {
      this.leftPanelButtonLabel = 'Chiudi';
      this.leftPanelClass = 'show-left-panel';
      this.leftPanelIcon = this.solidIcons.faBackward;
      this.leftPanelSize = 18;
      this.workareaSize = 55;
      this.rightPanelSize = 25;
      this.showLeftPanel = true;
    }
  }

  onFileSelected(filename: string) {
    this.imageLoaded = false;
    this.selectedFile.next(filename);
  }

  onImageLoaded(val) {
    this.imageLoaded = val;
  }
  
  toolClick(action: string) {
    if (action === 'print') {
      this.updatePrintData.next(true);
    }
    this.toolEvent.next(action);
  }

  changeScale(evt) {
    this.scaleEvent.next(evt);
  }

  onSave(evt) {
    this.savePlan.next(evt);
  }

  onSend(evt) {
    this.sendPlan.next(evt);
  }

  updateSelectedTool(action: string) {
    this.selectedTool.next(action);
  }

  onRowSelection(val: any) {
    this.rowSelection.next(val);
  }

  onUndoDelete(ids: string[]) {
    this.undoDelete.next(ids);
  }

  onUndoCreate(idx) {
    this.undoCreate.next(idx);
  }

  onUndoResizeMove(ids: string[]) {
    this.undoResizeMove.next(ids);
  }

  onUndoAssignDict(ids: string[]) {
    this.undoAssignDict.next(ids);
  }

  onRedoCreate(xx) {
    this.redoCreate.next(xx);
  }

  onRedoResizeMove(ids: string[]) {
    this.redoResizeMove.next(ids);
  }

  onRedoAssignDict(ids: string[]) {
    this.redoAssignDict.next(ids);
  }

  onDeleteElements(ids: string[]) {
    this.deleteElements.next(ids);
  }

  onPolygonSelection(rowId: string) {
    this.polygonSelection.next(rowId);
  }

  onDrawPolygon(points: [number, number][]) {
    this.drawPolygon.next(points);
  }

  onDrawRect(points: [number, number][]) {
    this.drawRect.next(points);
  }

  onResizePolygon(points: [number, number][]) {
    this.resizePolygon.next(points);
  }
}
